import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Holidays } from '../../../components/Holidays/Holidays';
import { Page } from '../../../components/Page/Page';
import { SchoolYearTable } from '../../../components/SchoolYear/SchoolYearTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SetupSchoolYears = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <Tab
        variant={'large'}
        tabs={[
          {
            title: t('schoolYear.title', { count: 2 }),
            value: 'schoolYear',
            content: <SchoolYearTable key={'schoolYear'} />,
          },
          {
            title: t('holidays.title', { count: 2 }),
            value: 'holidays',
            content: <Holidays key={'holidays'} />,
          },
        ]}
      />
    </Page>
  );
};
